import { render, staticRenderFns } from "./InvoiceIndex.vue?vue&type=template&id=428796a4&scoped=true"
import script from "./InvoiceIndex.vue?vue&type=script&lang=js"
export * from "./InvoiceIndex.vue?vue&type=script&lang=js"
import style0 from "./InvoiceIndex.vue?vue&type=style&index=0&id=428796a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428796a4",
  null
  
)

export default component.exports